<template>
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      
      color="#ffc107"
      :is-full-page="fullPage"
    ></loading>
   
    <div class="grid">
      <div class="col-12">
        <div class="card">
          <Toast />
          <Toolbar class="mb-4">

            <template v-slot:start>
              <div class="my-2">
                <Button
                  label="New"
                  icon="pi pi-plus"
                  class="p-button-success mr-2"
                  @click="openNew"
                />
                <!-- <Button
                  label="Delete"
                  icon="pi pi-trash"
                  class="p-button-danger"
                  @click="confirmDeleteSelected"
                  :disabled="!selectedProducts || !selectedProducts.length"
                /> -->
                <!-- &nbsp;
                <Button
                  icon="pi pi-sync"
                  class="p-button-info mr-2"
                  @click="get_list"
                /> -->
              </div>
            </template>
  
            <template v-slot:end>
              <Button
                label="Export"
                icon="pi pi-upload"
                class="p-button-help"
                @click="exportCSV($event)"
              />
            </template>
          </Toolbar>
  
          <DataTable
            :loading="loading"
            ref="dt"
            :lazy="true"
            :totalRecords="totalRecords"
            :paginator="true"
            :value="User"
            v-model:selection="selectedProducts"
            :dataKey="columns[0]"
            :rows="limit"
            :filters="filters"
            @page="onPage($event)"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25, totalRecords]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            responsiveLayout="scroll"
            style="font-size: 12px"
            :rowHover="true" showGridlines
          >
          <template #empty>
          <b style="text-align:center">No records found.</b>
        </template>
            <template #header>
              <div
                class="
                  flex flex-column
                  md:flex-row md:justify-content-between md:align-items-center
                "
              >
              <!-- {{ User}} -->
                <h5 class="m-0"><b>User Master</b></h5>
                    <Button icon="pi pi-refresh" @click="get_list()" />
                <!-- <span class="block mt-2 md:mt-0 p-input-icon-left">
                                  <i class="pi pi-search" />
                                  <InputText v-model="filters['global'].value" placeholder="Search..." />
                              </span> -->
              </div>
            </template>
  
            <!-- <Column v-for="(col,index) in columns" :field="col" :header="col.toUpperCase()" :key="index"></Column> 
             <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>  -->
  
            <Column header="Sr No" style="min-width: 5rem;text-align: center">
              <template #body="{ index}">
              <span v-if="page_no==1">{{ +index+ +1 }}</span>
                <span v-else>{{(+index+1)+limit*(page_no-1)}}</span>
              </template>
            </Column>
  
           
            <Column header="User Name" style="min-width: 5rem" :field="columns[1]">
              <template #body="{ data }">
                {{ data.userName }}
              </template>
            </Column>
            <Column header="First Name" style="min-width: 5rem" :field="columns[14]">
              <template #body="{ data }">
                {{ data.firstName}}
              </template>
            </Column>
            <Column header="Middle Name" style="min-width: 5rem" :field="columns[15]">
              <template #body="{ data }">
                {{ data.middleName}}
              </template>
            </Column>
            <Column header="Last Name" style="min-width: 5rem" :field="columns[16]">
              <template #body="{ data }">
                {{ data.lastName}}
              </template>
            </Column>
         
            <Column header="Mobile No" :field="columns[2]">
                <template #body="{ data }">
                  {{ data.mobileNo }}
                </template>
              </Column>
            <Column header="DOB" :field="columns[4]">
              <template #body="{ data }">
                {{ data.dob }}
              </template>
            </Column>
            <Column header="Email ID" :field="columns[3]">
              <template #body="{ data }">
                {{ data.emailID }}
              </template>
            </Column>
                      
            <Column header="Edit" headerStyle="min-width:5rem;">
              <template #body="slotProps">
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success mr-2"
                  @click="editProduct(slotProps.data)"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning mt-2"
                  @click="confirmDeletescheme(slotProps.data)"
                />
              </template>
            </Column>
          </DataTable>
  
          <Dialog
            v-model:visible="productDialog"
            :style="{ width: '600px', width: '600px' }"
            header="User Details"
            :modal="true"
            class="p-fluid"
          >
            <div class="grid">
              <div class="col-12 md:col-12">
                <div class="field">
                  <!-- <img
              :src="'images/product/shoes.jpg'"
              :alt="product.image"
              width="150"
              class="mt-0 mx-auto mb-5 block shadow-2"
            /> -->
                </div>
                <div class="field">
                  <label for="course">User Name</label>
                  <InputText
                    id="course"
                    v-model.trim="product.userName"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.course }"
                  />                
                </div>      
                <div class="field">
                  <label for="course">First Name</label>
                  <InputText
                    id="course"
                    v-model.trim="product.firstName"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.course }"
                  />                
                </div>
                <div class="field">
                  <label for="course">Middle Name</label>
                  <InputText
                    id="course"
                    v-model.trim="product.middleName"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.course }"
                  />                
                </div>
                <div class="field">
                  <label for="course">Last Name</label>
                  <InputText
                    id="course"
                    v-model.trim="product.lastName"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.course }"
                  />                
                </div>
                  <div class="field">
                      <label for="course">Mobile No</label>
                      <InputText
                        id="course"
                        v-model.trim="product.mobileNo"
                        required="true"
                        autofocus
                        :class="{ 'p-invalid': submitted && !product.course }"
                        type="number"
                      />
                    </div>
                    <div class="field">
                      <label for="course">Referal Code</label>
                      <InputText
                        id="course"
                        v-model.trim="product.referral_Code"
                        required="true"
                        autofocus
                        :class="{ 'p-invalid': submitted && !product.referral_Code }"
                        type="number"
                      />
                    </div>
                    <div class="field">
                      <label for="dob">Date of Birth</label>
                      <InputText
                        id="dob"
                        v-model.trim="dob"
                        required="true"
                        autofocus
                        :class="{ 'p-invalid': submitted && !product.dob }"
                        type="date"
                      />
                    </div>
                    <div class="field">
                      <label for="email">Email ID</label>
                      <InputText
                        id="email"
                        v-model.trim="product.emailID"
                        required="true"
                        autofocus
                        :class="{ 'p-invalid': submitted && !product.emailID }"
                        type="email"
                      />
                    </div>
                    <div class="field">
                      <label for="age">Age</label>
                      <InputText
                        id="age"
                        v-model.trim="product.age"
                        required="true"
                        autofocus
                        :class="{ 'p-invalid': submitted && !product.age }"
                        type="number"
                      />
                    </div>
                    <div class="field">
                      <label for="gender">Gender</label>
                      <Dropdown
                        id="gender"
                        v-model="gender"
                        :options="genders"
                        optionLabel="label"
                        
                        placeholder="Select Gender"
                        :class="{ 'p-invalid': submitted && !product.gender }"
                      />
                    </div>
                    <div class="field">
                      <label for="status">Status</label>
                      <Dropdown
                        id="status"
                        v-model="status"
                        :options="statuses"
                        optionLabel="label"
                        
                        placeholder="Select Status"
                        :class="{ 'p-invalid': submitted && !product.status }"
                      />
                    </div>
  
  
  
              </div>
              <div class="col-12 md:col-6">
                <Button
                  v-if="product.userID"
                  label="UPDATE"
                  icon="pi pi-check"
                  class="p-button-success mr-1 mb-1"
                  @click="edituser"
                 
                />
                <Button
                  v-else
                  label="ADD"
                  icon="pi pi-check"
                  class="p-button-success mr-1 mb-1"
                  @click="Adduser"
                />
  
              </div>
              <div class="col-12 md:col-6">
                <Button
                  label="Cancel"
                  icon="pi pi-times"
                  class="p-button-danger mr-1 mb-1"
                  @click="productDialog = false;"
                />
              </div>
            </div>
          </Dialog>
  
          <Dialog
            v-model:visible="deleteschemeDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="flex align-items-center justify-content-center">
              <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
              />
              <span v-if="product"
                >Are you sure you want to delete <b>{{ product.userName }}</b
                >?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteschemeDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteVideo"
              />
            </template>
          </Dialog>
  
          <Dialog
            v-model:visible="deleteProductsDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="flex align-items-center justify-content-center">
              <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
              />
              <span v-if="product"
                >Are you sure you want to delete the selected Scheme?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteProductsDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteSelectedProducts"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { FilterMatchMode } from "primevue/api";
  import ProductService from "../service/ProductService";
  //import FormNewsMaster from "@/components/FormNewsMaster";
  //import * as Survey from "survey-vue";
  
  // import axios from "axios";
  import apis from "@/apis";
  import axios from "axios";
  
  export default {
    data() {
      return {
        page_no:1,
        Price:"",
        dob:'',
        gender: null,
        status: null,
        isLoading:false,
              isLoadingModel:false,
              loading: false,
              fullPage:true,
        file_attachment: "",
        dropdownItems: [
          { name: "Motivational", value: "Motivational" },
          { name: "Interview", value: "Interview" },
        ],
        dropdownItems2: [
          { name: "Active", value: "Active" },
          { name: "InActive", value: "InActive" },
          // { name: "Deleted", value: "Deleted" }
        ],
         gender: null,
        // statuses: null,
        genders: [
        { label: 'Male', value: '1' },
        { label: 'Female', value: '2' }
      ],
      statuses: [
        { label: 'Active', value: '1' },
        { label: 'Inactive', value: '2' },
        
      ],
        User: null,
        productDialog: false,
        deleteschemeDialog: false,
        deleteProductsDialog: false,
        lazyParams: {},
        product: {},
        selectedProducts: null,
        filters: {},
        offset: 1,
        selectstatus: null,
        selectstatus2: { name: "Motivational", value: "Motivational" },
        limit: 10,
        columns: [],
        head: [
          "Data Usages",
          "Network Connectivity",
          "Students",
          "Teachers",
          "Student Registration",
          "News Master",
          "Government Panel",
          "Feedback Master",
          "User Queries",
          "Schemes Master",
          "Notice Master",
          "Subject Master",
          "Teacher Schedule Master",
          "Teacher Schedule DE Master",
          "Query Types Master",
          "Sub Query Types Master",
          "Admin Users",
          "Application Roles",
          "Departments",
          "Cast Master",
          "Year Master",
          "District Master",
          "Student Attendance",
          "Student Document",
          "Teachers",
          "Radical ids",
          "Subject Topics",
          "Query Comments",
          "Student Submit Answers",
          "Mock Tests",
          "Mock Test Papers",
          "Mock Test Results",
          "Video",
          "Syllabus",
          "User"
        ],
        pageno: 1,
        submitted: false,
        totalRecords: 0,
        id: "",
        statuses2: [
          { label: "INSTOCK", value: "instock" },
          { label: "LOWSTOCK", value: "lowstock" },
          { label: "OUTOFSTOCK", value: "outofstock" },
        ],
      };
    },
    productService: null,
    async created() {
      this.productService = new ProductService();
      this.initFilters();
    },
    async mounted() {
      // this.productService.getProducts().then(data => this.products = data);
      this.id = this.$route.params.id;
  
      this.lazyParams = {
        first: 0,
        rows: this.limit,
        sortField: null,
        sortOrder: null,
        filters: this.filters,
      };
      if (this.totalRecords == 0) {
        await this.get_count();
      }
      await this.get_list();
      //alert(this.id);
    },
    watch: {
      async $route() {
        this.User = [];
        this.columns = [];
        this.totalRecords = 0;
        this.id = this.$route.params.id;
        if (this.id) {
          await this.get_count();
          this.get_list();
        }
      },
    },
    methods: {
      handleFileUpload() {
        this.file_attachment = this.$refs.file_attachment.files[0];
  
        //alert(this.$refs.file_attachment.files[0].name);
      },
      async onPage(event) {
        this.lazyParams = event;
        this.page_no = event.page + 1;
        this.limit = event.rows;
        // console.log(event);
        await this.get_count();
        if (this.totalRecords > 0) {
          this.get_list();
        }
      },
      get_count: function () {
        var data = {
          count: true,
        };
        this.loading = true;
        var promise = apis.AdminUserlist(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.totalRecords = response.data.data;
          //alert(this.totalRecords);
        });
  
        console.log(data);
      },
      get_list: function () {
        var data = {
          Limit: this.limit,
          page_no: this.page_no,
          count: false,
        };
        this.loading = true;
        var promise = apis.AdminUserlist(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.User = response.data.data;
          console.log(this.User[0]);
          if (this.columns.length == 0) {
            if (this.User.length > 0) {
              this.columns = Object.keys(this.User[0]);
            }
          }
        });
      },
      formatCurrency(value) {
        if (value)
          return value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
        return;
      },
      openNew() {
        this.product = {};
        this.submitted = false;
        this.productDialog = true;
      },
      hideDialog() {
        this.productDialog = false;
        this.submitted = false;
      },
    async Adduser() {
      this.submitted = true;
      if(!this.product.userName)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please Enter User name",
              life: 3000,
            });
            return false;
      }
      if(!this.product.mobileNo)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please Enter Mobile no",
              life: 3000,
            });
            return false;
      }
      if(!this.product.dob)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please Enter DOB",
              life: 3000,
            });
            return false;
      }
      if(!this.product.emailID)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please Enter Email id",
              life: 3000,
            });
            return false;
      }
      if(!this.product.age)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please Enter Age",
              life: 3000,
            });
            return false;
      }
      if(!this.product.gender)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please select Gender",
              life: 3000,
            });
            return false;
      }
      if(!this.product.status)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please select Status",
              life: 3000,
            });
            return false;
      }
          var data = {
            
            UserName: this.product.userName,
            MobileNo: this.product.mobileNo,
            DOB: this.product.dob,
            EmailID: this.product.emailID,
            Age: this.product.age,
            Gender: this.product.gender,
            CreatedBy: localStorage.getItem("id"),
            UpdatedBy: localStorage.getItem("id"),
            Referral_Code: this.product.referral_Code,
            FirstName : this.product.firstName,
            MiddleName: this.product.middleName, 
            LastName: this.product.lastName,
            IsActive: this.product.status
            
          };
          this.isLoadingModel = true;
          var promise = apis.addUsermaster(data);
          promise
            .then((responseapi) => {
              this.$swal(responseapi.data.message);
              this.isLoadingModel = false;
              this.productDialog = false;
              this.get_list();
              this.get_count();
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
               this.get_list();
               this.get_count();
  
            });
            
         this.status={name:"",value:""}
         this.gender={name:"",value:""}
        
       },
        //add-----------------------------------------------------------------------------------------------------------------
      edituser() {
      this.submitted = true;
      if(!this.product.userName)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please Enter User name",
              life: 3000,
            });
            return false;
          }
          if(!this.product.mobileNo)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please Enter Mobile no",
              life: 3000,
            });
            return false;
      }
      if(!this.product.dob)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please Enter DOB",
              life: 3000,
            });
            return false;
      }
      if(!this.product.emailID)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please Enter Email id",
              life: 3000,
            });
            return false;
      }
      if(!this.product.age)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please Enter Age",
              life: 3000,
            });
            return false;
      }
      if(!this.gender)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please select Gender",
              life: 3000,
            });
            return false;
      }
      if(!this.status)
      {
      this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Please select Status",
              life: 3000,
            });
            return false;
      }
         
          var data = 
          {
            UserID : this.product.userID,
            UserName: this.product.userName,
            MobileNo: this.product.mobileNo,
            DOB: this.product.dob,
            EmailID: this.product.emailID,
            Age: this.product.age,
            Gender: this.product.gender,
            CreatedBy: localStorage.getItem("id"),
            UpdatedBy: localStorage.getItem("id"),
            Referral_Code: this.product.referral_Code,
            FirstName : this.product.firstName,
            MiddleName: this.product.middleName, 
            LastName: this.product.lastName,
            IsActive: this.product.status
          };
          this.isLoadingModel = true;
          var promises = apis.editUsermaster(data);
          promises
            .then((responseapi) => {
              
              this.isLoadingModel = false;
              this.productDialog = false;
              this.$swal(responseapi.data.message);
              this.get_list();
              this.get_count();
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
      
  
         this.selectstatus={name:"",value:""}
         
      },
      saveProduct() {
        this.submitted = true;
        if (this.product.name.trim()) {
          if (this.product.id) {
            this.product.inventoryStatus = this.product.inventoryStatus.value
              ? this.product.inventoryStatus.value
              : this.product.inventoryStatus;
            this.product[this.findIndexById(this.product.id)] = this.product;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Product Updated",
              life: 3000,
            });
          } else {
            this.product.id = this.createId();
            this.product.code = this.createId();
            this.product.image = "product-placeholder.svg";
            this.product.inventoryStatus = this.product.inventoryStatus
              ? this.product.inventoryStatus.value
              : "INSTOCK";
            this.product.push(this.product);
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Product Created",
              life: 3000,
            });
          }
          this.productDialog = false;
          this.product = {};
        }
      },
      editProduct(product) {
        this.file_attachment = "";
        this.product = { ...product };
        this.productDialog = true;

        // this.gender = 1;
  
        this.gender={label:this.product.gender==1?'Male':'Female',value:this.product.gender==1?'1':'2'}
        this.status={label:this.product.isActive==1?'Active':'InActive',value:this.product.isActive==1?'1':'2'}

        this.product.dob = dob;
  
        // this.selectstatus.value = this.product.status;
        // this.selectstatus.name = this.product.status;
     
        // this.selectstatus.value = this.product.type;
        // this.selectstatus.name = this.product.type;
  
        // this.selectstatus2.value = this.product.status;
        // this.selectstatus2.name = this.product.status;
  
        // this.file_attachment = this.product.image;
      },
      confirmDeletescheme(product) {
        this.product = product;
        this.deleteschemeDialog = true;
        // if (this.product.IsActive == 1) {
        //   this.deleteschemeDialog = true;
        // }else{
        //   this.$swal("Already Deleted");
        // }
        
       
      },
      deleteProduct() {
        this.product = this.product.filter((val) => val.id !== this.product.id);
        this.deleteschemeDialog = false;
        this.product = {};
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Scheme Deleted",
          life: 3000,
        });
      },
  
      deleteVideo() {
       
          var data = {
            userID: this.product.userID,
          };
          this.isLoadingModel = true;
          var promise = apis.deleteUsermaster(data);
          promise.then((responseapi) => {
            this.isLoadingModel = false;
            if (responseapi.status == 200) {
              
              // this.hideDialog1();
              this.deleteschemeDialog = false;
              this.$swal(responseapi.data);
              this.get_list();
              this.get_count();
            } else {
              this.$swal("error to Delete Scheme");
            }       
          });   
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.product.length; i++) {
          if (this.product[i].id === id) {
            index = i;
            break;
          }
        }
        return index;
      },
      createId() {
        let id = "";
        var chars =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      exportCSV() {
        this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteProductsDialog = true;
      },
      deleteSelectedProducts() {
        this.product = this.product.filter(
          (val) => !this.selectedProducts.includes(val)
        );
        this.deleteProductsDialog = false;
        this.selectedProducts = null;
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Products Deleted",
          life: 3000,
        });
      },
      initFilters() {
        this.filters = {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
      },
    },
    components: {},
  };
  </script>
  
  <style scoped lang="scss">
  @import "../assets/demo/badges.scss";
  </style>
  